/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var InputVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputVisualModelExport, _super);
    function InputVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.h = 0;
        _this.f = 0;
        _this.c = 0;
        _this.b = 0;
        _this.j = null;
        _this.m = null;
        _this.d = false;
        _this.a = null;
        _this.q = null;
        _this.r = null;
        _this.s = null;
        _this.g = 0;
        _this.o = null;
        _this.p = null;
        _this.i = null;
        _this.l = null;
        _this.e = false;
        _this.t = null;
        _this.k = null;
        return _this;
    }
    InputVisualModelExport.prototype.n = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("top : " + this.h + ", ");
        a.l("left : " + this.f + ", ");
        a.l("shiftType : " + this.c + ", ");
        a.l("actualDensity : " + this.b + ", ");
        a.l("mask : \"" + this.j + "\", ");
        a.l("promptChar : \"" + this.m + "\", ");
        a.l("includeLiterals : " + this.d + ", ");
        a.l("actualTextColor : " + this.a.serialize() + ", ");
        if (!stringIsNullOrEmpty(this.q)) {
            a.l("textStyleFontStyle : \"" + this.q + "\", ");
        }
        if (!stringIsNullOrEmpty(this.r)) {
            a.l("textStyleFontVariant : \"" + this.r + "\", ");
        }
        if (!stringIsNullOrEmpty(this.s)) {
            a.l("textStyleFontWeight : \"" + this.s + "\", ");
        }
        if (!stringIsNullOrEmpty(this.o)) {
            a.l("textStyleFontFamily : \"" + this.o + "\", ");
        }
        if (!stringIsNullOrEmpty(this.p)) {
            a.l("textStyleFontStretch : \"" + this.p + "\", ");
        }
        if (!isNaN_(this.g)) {
            a.l("textStyleFontSize : " + this.g + ", ");
        }
        a.l("inputType : \"" + this.i + "\", ");
        a.l("placeholder : \"" + this.l + "\", ");
        a.l("isHover : " + this.e + ", ");
        a.l("value : \"" + this.t + "\", ");
        a.l("name : \"" + this.k + "\", ");
        a.l("}");
        return a.toString();
    };
    InputVisualModelExport.$t = markType(InputVisualModelExport, 'InputVisualModelExport');
    return InputVisualModelExport;
}(Base));
export { InputVisualModelExport };
//# sourceMappingURL=InputVisualModelExport.js.map
